import { useState, useEffect } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const mobileBreakpoint = 1250;

  // 1. Close sidebar on window resize (desktop)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > mobileBreakpoint && open) {
        setOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [open]);

  // 🛑 Removed useEffect for "Push" effect (content-shifted class) 🛑

  // Handle link click to close sidebar
  const handleLinkClick = () => {
    if (open) {
      setOpen(false);
    }
  };

  // Handle menu toggle
  const handleMenuToggle = () => {
    setOpen(!open);
  };

  return (
    <header className="fixed-header">
      {/* Top Navbar */}
      <nav className="navbar">
        <div className="logo-title">
          <a href="/">
            <img src={logo} alt="Logo" className="logo" />
          </a>
          <div className="titleContainer">
            <h1>M D Tours and Travels</h1>
            {/* <p>Travel with Ease, Travel with Us..</p> */}
            <p>Travel with Ease, Travel with Us.</p>
          </div>
        </div>

        {/* Desktop Menu */}
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/international">International</Link>
          <Link to="/domestic">Domestic</Link>
          {/* <Link to="/cruise">Cruise</Link> */}
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>

        {/* Mobile Toggle Button (Hamburger) */}
        <button className="menu-btn" onClick={handleMenuToggle}>
          {"☰"}
        </button>
      </nav>

      {/* Sidebar: Open class is added/removed based on state */}
      <aside className={`sidebar ${open ? "open" : ""}`}>
        {/* Close button is correctly placed inside the sidebar */}
        <button className="close-btn" onClick={() => setOpen(false)}>
          ✖
        </button>

        <ul>
          <li onClick={handleLinkClick}>
            <Link to="/">Home</Link>
          </li>
          <li onClick={handleLinkClick}>
            <Link to="/international">International</Link>
          </li>
          <li onClick={handleLinkClick}>
            <Link to="/domestic">Domestic</Link>
          </li>
          {/* <li onClick={handleLinkClick}>
            <Link to="/cruise">Cruise</Link>
          </li> */}
          <li onClick={handleLinkClick}>
            <Link to="/about">About</Link>
          </li>
          <li onClick={handleLinkClick}>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </aside>
    </header>
  );
}
